export enum FamilyHealthStatus {
  NOT_CREATED = 'NOT_CREATED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  ACTIVE = 'ACTIVE'
}
